// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"1d1b6daa","227":"fdb07100","232":"026bb72c","237":"7ddb5174","526":"fd5c798a","787":"8e5b9c47"}[chunkId] + ".chunk.js";
};